import type { SupportedLanguage } from '@/lib/i18n/config';
import type { DateTimePreferences } from '../types';

export const getDefaultDateTimePreferences = (
  language: SupportedLanguage
): DateTimePreferences =>
  language === 'ja'
    ? { dateFormat: 'year_month_day', timeFormat: 'twenty_four_hour' }
    : { dateFormat: 'month_day_year', timeFormat: 'twelve_hour' };
